import {Pillar2ComplianceLegendsComponent} from './components/sidenotes/pillar2-compliance-legends/pillar2-compliance-legends.component';
import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';

export class Pillar2ComplianceDynamicComponentHelper {
  public static components: any;

  public static init() {
    if (Pillar2ComplianceDynamicComponentHelper.components) {
      return;
    }
    const components = {};
    components['Pillar2ComplianceLegendsComponent'] = Pillar2ComplianceLegendsComponent;
    Pillar2ComplianceDynamicComponentHelper.components = components;
    RootDynamicComponentHelper.merge(components);
  }

  public static register(key: string, component: any) {
    Pillar2ComplianceDynamicComponentHelper.components[key] = component;
    RootDynamicComponentHelper.register(key, component);
  }
}
